import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  imports: [
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatTableModule,
    MatTooltipModule,
    MatMenuModule,
    /*

    MatBadgeModule,

    
    MatToolbarModule,

    MatCardModule,
    MatButtonToggleModule,
    

    MatSelectModule,

    MatNativeDateModule,

    MatAutocompleteModule,
    MatSidenavModule,

    MatStepperModule,
    MatSlideToggleModule,
    ,
    
    MatRadioModule,
    MatChipsModule,
    MatTabsModule,
    MatListModule,
    */
  ],
  exports: [
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatTableModule,
    MatTooltipModule,
    MatMenuModule,
    /*

    MatBadgeModule,

    
    MatToolbarModule,

    MatCardModule,
    MatButtonToggleModule,
    

    MatInputModule,
    MatSelectModule,
    
    MatSnackBarModule,
    MatAutocompleteModule,
    MatSidenavModule,

    MatStepperModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatTooltipModule,
    MatRadioModule,
    MatChipsModule,
    MatTabsModule,
    MatListModule,
    MatSortModule,
    */
  ],
})
export class MaterialModule {}
